import P, { P2 } from "../../components/Paragraph";
import Button from "../../components/Button";
import useLang from "../../hooks/useLang";
import styles from "./modelEvaluation.module.css";

const ModelEvaluation = () => {
  const lang = useLang();
  const currentVersion = 12;
  const previousVersion = 11;
  const currentTP = 10;
  const previousTP = 9;
  const currentFN = 5;
  const previousFN = 6;
  const currentFP = 7;
  const previousFP = 8;
  const currentTN = 15;
  const previousTN = 16;

  return (
    <div
      style={{
        display: "flex",
        gap: "var(--gap)",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      <div style={{ height: "var(--size-4)" }} />
      <P>{`${lang("captions.version")}: ${currentVersion}`}</P>
      <Button>{lang("model.fall_back_to_previous_version")}</Button>
      <div style={{ height: "var(--size-4)" }} />
      <P>{`${lang(
        "model.evaluation_compared_to_previous"
      )} (${previousVersion})`}</P>
      <div className={styles.modelEvaluationTable}>
        <div className={styles.modelEvaluationRow}>
          <div className={styles.modelEvaluationCell}>
            <P2 style={{ color: "var(--color-base)", fontWeight: "600" }}>
              {lang("model.true_positive")}
            </P2>
            <P>{currentTP}</P>
            <P2>{lang("model.previous_model")}</P2>
            <P style={{ color: "var(--color-meta)" }}>{previousTP}</P>
          </div>
          <div className={styles.modelEvaluationCell}>
            <P2 style={{ color: "var(--color-base)", fontWeight: "600" }}>
              {lang("model.false_negative")}
            </P2>
            <P>{currentFN}</P>
            <P2>{lang("model.previous_model")}</P2>
            <P style={{ color: "var(--color-meta)" }}>{previousFN}</P>
          </div>
        </div>
        <div className={styles.modelEvaluationRow}>
          <div className={styles.modelEvaluationCell}>
            <P2 style={{ color: "var(--color-base)", fontWeight: "600" }}>
              {lang("model.false_positive")}
            </P2>
            <P>{currentFP}</P>
            <P2>{lang("model.previous_model")}</P2>
            <P style={{ color: "var(--color-meta)" }}>{previousFP}</P>
          </div>
          <div className={styles.modelEvaluationCell}>
            <P2 style={{ color: "var(--color-base)", fontWeight: "600" }}>
              {lang("model.true_negative")}
            </P2>
            <P>{currentTN}</P>
            <P2>{`${lang("model.previous_model")}:`}</P2>
            <P style={{ color: "var(--color-meta)" }}>{previousTN}</P>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModelEvaluation;
